import React, { useState } from "react";

const DragDropList = ({ items, renderItem ,onOrderChange }) => {
  //const [items, setItems] = useState(initialItems);
  const [draggedIndex, setDraggedIndex] = useState(null);

  // Handle drag start
  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  // Handle drag over (prevents default behavior)
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Handle drop (reorder items)
  const handleDrop = (index) => {
    if (draggedIndex === null) return;

    const newItems = [...items];
    const draggedItem = newItems.splice(draggedIndex, 1)[0]; // Remove dragged item
    newItems.splice(index, 0, draggedItem); // Insert at new position

    //setItems(newItems);
    setDraggedIndex(null);
    onOrderChange(newItems);
  };

  // Add new item
  

  // Remove item
  const handleRemoveItem = (id) => {
    onOrderChange(items.filter((item) => item.id !== id));
     
  };

  return (
    <div>
      

      <div className="">
        {items.map((item, index) =>
          renderItem({
            item,
            index,
            handleDragStart,
            handleDragOver,
            handleDrop,
            handleRemoveItem,
          })
        )}
      </div>
    </div>
  );
};

export default DragDropList;
